import { Box, IconButton, Typography } from "@mui/material";
import type { SvgIconComponent } from "@mui/icons-material";

interface Props {
  icon: SvgIconComponent;
  label: string;
  onClick?: () => void;
  danger?: boolean;
  disabled?: boolean;
}

/** Real-WHB-style action row: circular icon button with label under it. */
export function CircularActionButton({ icon: Icon, label, onClick, danger, disabled }: Props) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.75,
        minWidth: 64
      }}
    >
      <IconButton
        onClick={onClick}
        disabled={disabled}
        sx={(theme) => ({
          width: 56,
          height: 56,
          bgcolor: theme.palette.mode === "dark" ? "grey.800" : "grey.100",
          color: danger ? "error.main" : "text.primary",
          "&:hover": {
            bgcolor: theme.palette.mode === "dark" ? "grey.700" : "grey.200"
          }
        })}
      >
        <Icon />
      </IconButton>
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: disabled ? "text.disabled" : "text.secondary" }}
      >
        {label}
      </Typography>
    </Box>
  );
}
